import type { RouteRecordRaw } from 'vue-router';

export const newsRoutes: Array<RouteRecordRaw> = [
  {
    path: '/trade/news',
    name: 'tradeNews',
    redirect: '/trade/news/list',
    component: () => import('pages/trade/admin/news/McNews.vue'),
    meta: {
      title: 'News - Articles Publication',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeNewsList',
        component: () => import('pages/trade/admin/news/NewsList.vue'),
        meta: {
          title: 'News List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeNewsDetail',
        component: () => import('pages/trade/admin/news/NewsDetail.vue'),
        meta: {
          title: 'News Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeNewsNew',
        component: () => import('pages/trade/admin/news/NewsNew.vue'),
        meta: {
          title: 'New News',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'tradeNewsExplorer',
        component: () => import('pages/trade/admin/news/NewsExplorer.vue'),
        meta: {
          title: 'News Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/users/news',
    name: 'tradeUserNews',
    redirect: '/trade/users/news/explorer',
    component: () => import('pages/trade/users/news/UserNews.vue'),
    meta: {
      title: 'News - Articles Publication',
      requiresAuth: true,
    },
    children: [
      {
        path: 'explorer',
        name: 'tradeUserNewsExplorer',
        component: () => import('pages/trade/users/news/NewsExplorer.vue'),
        meta: {
          title: 'News Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
];
